import cellEditFactoryModule, { Type } from 'react-bootstrap-table2-editor';

export const cellEditFactory =
  cellEditFactoryModule.default ?? cellEditFactoryModule;

export { Type };
